import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Shifts = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M24 13.075V11C24 8.238 21.762 6 19 6H18V5C18 4.45 17.55 4 17 4C16.45 4 16 4.45 16 5V6H12V5C12 4.45 11.55 4 11 4C10.45 4 10 4.45 10 5V6H9C6.237 6 4 8.238 4 11V19C4 21.762 6.237 24 9 24H13.075C14.462 26.387 17.05 28 20 28C24.413 28 28 24.413 28 20C28 17.05 26.387 14.463 24 13.075ZM12.25 22H9C7.35 22 6 20.65 6 19V11C6 9.35 7.35 8 9 8H10V9C10 9.55 10.45 10 11 10C11.55 10 12 9.55 12 9V8H16V9C16 9.55 16.45 10 17 10C17.55 10 18 9.55 18 9V8H19C20.65 8 22 9.35 22 11V12.25C21.363 12.088 20.687 12 20 12C15.588 12 12 15.588 12 20C12 20.688 12.088 21.363 12.25 22ZM20 26C16.687 26 14 23.312 14 20C14 16.688 16.688 14 20 14C23.312 14 26 16.688 26 20C26 23.312 23.312 26 20 26Z" />
		<path d="M21.25 16C20.7 16 20.25 16.45 20.25 17V19.587L18.538 21.299C18.363 21.474 18.25 21.724 18.25 22.011C18.25 22.561 18.7 23.011 19.25 23.011C19.525 23.011 19.775 22.898 19.962 22.723L21.962 20.723C22.15 20.535 22.25 20.285 22.25 20.011V17.011C22.25 16.448 21.8 15.999 21.25 15.999V16Z" />
	</svg>
);

export default Shifts;
